import React, { useEffect } from 'react';
import './SlideOver.css';

export default function SlideOver({ 
  open, 
  onClose, 
  title, 
  children, 
  side = 'right', 
  width = 440 
}) {
  useEffect(() => {
    const onEsc = (e) => e.key === 'Escape' && onClose?.();
    if (open) document.addEventListener('keydown', onEsc);
    return () => document.removeEventListener('keydown', onEsc);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="so-overlay" onMouseDown={onClose}>
      <aside
        className={`so-panel so-${side}`}
        style={{ width }}
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <header className="so-header">
          <h2>{title}</h2>
          <button className="so-close" onClick={onClose}>×</button>
        </header>
        <div className="so-body">{children}</div>
      </aside>
    </div>
  );
}
